import { useState } from "react";
import API from "../api";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/images/logo.jpg";

export default function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const submit = async () => {
    try {
      const res = await API.post("/auth/login", form);
      localStorage.setItem("noatoken", res.data.noatoken);
      navigate("/");
    } catch {
      alert("Invalid credentials");
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow w-full max-w-md">
        
        <img 
          src={logo} 
          alt="Logo" 
          className="h-20 mx-auto mb-2"
        />
        
        <h2 className="text-2xl font-bold text-center mb-6">
        Climate - Connect -Capital - IPO
        </h2>

        <label>Email</label>
        <input
          className="w-full border p-2 rounded mt-1 mb-4"
          placeholder="Enter email"
          onChange={e => setForm({ ...form, email: e.target.value })}
        />

        <label>Password</label>
        <input
          type="password"
          className="w-full border p-2 rounded mt-1 mb-4"
          placeholder="Enter password"
          onChange={e => setForm({ ...form, password: e.target.value })}
        />

        <div className="text-right mb-4">
          <Link
            to="/forgot-password"
            className="text-sm text-green-600 hover:underline"
          >
            Forgot Password?
          </Link>
        </div>

        <button
          onClick={submit}
          className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600"
        >
          Login
        </button>

        <p className="text-sm text-center mt-4">
          Don’t have an account?{" "}
          <Link to="/onboarding" className="text-green-600 font-semibold">
            Register
          </Link>
        </p>
      </div>
    </div>
  );
}